import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { ApiLog } from 'dashboard/models/api-log';
import { clearApiLog, setApiLog } from 'dashboard/redux/actions/api-log';
import { ApiEndpoint } from 'lib/interfaces/api';

export function loadApiLog(id: string) {
  return async (dispatch: Dispatch) => {
    dispatch(clearApiLog());
    const apiLogResponse = await SessionClientDashboard.getResource<ApiLog>(ApiEndpoint.ApiLog, id);

    const apiLog = apiLogResponse.data;

    dispatch(setApiLog(apiLog));
  };
}
